import { render, staticRenderFns } from "./TrendCards.vue?vue&type=template&id=9fe55800&scoped=true"
import script from "./TrendCards.vue?vue&type=script&lang=js"
export * from "./TrendCards.vue?vue&type=script&lang=js"
import style0 from "./TrendCards.vue?vue&type=style&index=0&id=9fe55800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe55800",
  null
  
)

export default component.exports